module.exports = __webpack_public_path__ + "static/media/boss-hidden-power-block-not-select.7100a24f.png";